// Module-level memory token — never written to localStorage.
// Shared between the auth context and axios interceptors.
let memoryToken: string | null = null

export const setMemoryToken = (token: string | null): void => {
  memoryToken = token
}

export const getMemoryToken = (): string | null => memoryToken
